import { Block } from "@blocks/Blocks";
import EventsAwardsNavigationMenu from "@events-awards/components/EventsAwardsNavigationMenu";
import { eEQuickLinksMenu } from "@events-awards/EE/utils/constants";

export default function EventsAwardsE50QuickLinks(): React.ReactElement {
  return (
    <Block rootClassName="py-18">
      <h2 className="mb-6 border-b border-gray-175 pb-3 text-left font-public-sans text-base font-bold leading-5">
        {"EMERGING ENTERPRISE ©"}
      </h2>

      <div className="flex">
        <h3 className="mr-auto text-left font-public-sans text-lg font-normal">
          Quicklinks
        </h3>

        <EventsAwardsNavigationMenu
          menuData={eEQuickLinksMenu}
          className="m-0 border-0 p-0"
          linkClassName="after:bg-eventAwards-ee-accent text-base font-public-sans font-light after:right-0"
        />
      </div>
    </Block>
  );
}
